
const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, string> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as any;
    
    if (!messages[lang]) {
      messages[lang] = { translation: {} };
    }
    
    // Merge all exported constants into translation object
    Object.keys(module).forEach(key => {
      if (key !== 'default' && typeof module[key] === 'object') {
        const sectionData = module[key];
        Object.keys(sectionData).forEach(subKey => {
          messages[lang].translation[`${key}.${subKey}`] = sectionData[subKey];
        });
      }
    });
  }
});

export default messages;
